import { useState, useEffect } from "react";
import api from "@/lib/api";
import { SoccerBall } from "@phosphor-icons/react";

// Fetches a team's logo as an authenticated blob (img tags can't send auth headers reliably)
export default function TeamLogo({ teamId, logoPath, className = "", size = 40 }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let revoke = null;
    let active = true;
    if (!logoPath || !teamId) {
      setSrc(null);
      return;
    }
    (async () => {
      try {
        const res = await api.get(`/teams/${teamId}/logo`, { responseType: "blob" });
        if (!active) return;
        const url = URL.createObjectURL(res.data);
        revoke = url;
        setSrc(url);
      } catch (e) {
        setSrc(null);
      }
    })();
    return () => {
      active = false;
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [teamId, logoPath]);

  if (src) {
    return (
      <img
        src={src}
        alt="Team logo"
        data-testid="team-logo-img"
        className={`object-cover ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <div
      className={`flex items-center justify-center bg-[#1C1C1E] border border-zinc-800 ${className}`}
      style={{ width: size, height: size }}
      data-testid="team-logo-placeholder"
    >
      <SoccerBall size={size * 0.5} className="text-zinc-600" weight="fill" />
    </div>
  );
}
